import {createAction, props} from '@ngrx/store';
import {State} from './feature.module';

const area = '[Settings]'

/**
 * Get records actions
 */

export const loadRecords = createAction(
    `${area} Load records`,
);

export const loadRecordsSuccess = createAction(
    `${area} Load records success`,
    props<Partial<State>>()
);

